export const DEFAULT_SKU_TAGS_DETAIL = {
  name: '',
  description: '',
}
